export const usersData = [
  {
    userID: 1134596345,
    firstName: "Bukky",
    lastName: "Owolabi",
    phonePrefix: 234,
    phoneNumber: "8130403459",
    address: "60 Landbridge Oniru-Estate",
    town: "Victoria Island",
    city: "Lagos",
    defaultAddress: false,
  },
  {
    userID: 113657863,
    firstName: "Johnny",
    lastName: "Doe",
    phonePrefix: 234,
    phoneNumber: "8145435348",
    address: "12 Adebola Igbenisan Street",
    town: "Ikotun",
    city: "Lagos",
    defaultAddress: true,
  },
  {
    userID: 113757863,
    firstName: "Banny",
    lastName: "Yunnan",
    phonePrefix: 234,
    phoneNumber: "8145435348",
    address: "82 Majekodunmi Igbenisan Street",
    town: "Bodija",
    city: "Ibadan",
    defaultAddress: false,
  },
];
